import { useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { t, useLocale } from '../lib/i18n.js';

export function SiteFooter() {
  useLocale();
  const navigate = useNavigate();
  const taps = useRef(0);
  const openOddMode = () => {
    taps.current += 1;
    if (taps.current >= 7) {
      taps.current = 0;
      navigate('/odd');
    }
  };
  return (
    <footer className="site-footer">
      <span>
        <button className="site-footer__secret" type="button" onClick={openOddMode}>
          Listen &amp; Draw
        </button>{' '}
        <span className="muted">
          · {t('A little listening. A little intuition.', '耳とひらめきで、遊ぼう。')}
        </span>
      </span>
      <div>
        <Link to="/help">{t('Help & feedback', 'ヘルプ・ご意見')}</Link>
        <Link to="/privacy">{t('Privacy', 'プライバシー')}</Link>
        <Link to="/press">{t('Press kit', '紹介素材')}</Link>
      </div>
    </footer>
  );
}
